import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { UserAccountRegDto } from 'src/app/core/dtos/dto';
import { TestTypeEnum } from 'src/app/core/dtos/enum';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';

@Component({
  selector: 'app-cancel-registration',
  templateUrl: './cancel-registration.component.html',
  styleUrls: ['./cancel-registration.component.scss']
})
export class CancelRegistrationComponent implements OnInit {

  isSaftTest: boolean;
  testInfo: UserAccountRegDto;
  testTypeName: string;
  errorMessage: string;
  successMessage: string;
  regId: number;
  isRegistrationCancelRequested: boolean;
  title: string;

  constructor(
    private accountService: AccountService,
    private actRoute: ActivatedRoute,
    private toastService: HotToastService,
    private router: Router
  ) {
    this.isRegistrationCancelRequested = false;
  }

  ngOnInit(): void {
    this.regId = this.actRoute.snapshot.params.regId;
    this.getRegistrationDetails(this.regId);
  }

  getRegistrationDetails(regId: number) {
    this.accountService.getRegistrationDetails(regId)
      .subscribe(result => {
        this.testInfo = result.content;
        const testTypeId = Number(this.testInfo.testTypeId);
        if (testTypeId === TestTypeEnum.CELPIP_SAFT || testTypeId === TestTypeEnum.SAFT || testTypeId === TestTypeEnum.CAEL_SAFT) {
          this.isSaftTest = true;
        }
        if (this.isSaftTest === true) {
          this.testTypeName = this.testInfo.testTypeName;
        } else {
          this.testTypeName = this.testInfo.testTypeName + " Test";
        }
        this.title = `Cancel ${this.testTypeName} Registration`;
      },
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            if (errorMessage?.reasons) {
              errorMessage.reasons.forEach(reasons => {
                this.toastService.warning(reasons.errorMessage);
              });
            }
            else {
              this.toastService.warning("Unable to load test registration info");
            }
          }
          this.router.navigate(['my-account']);
        });

    this.checkCancellationRequested();
  }

  requestCancellation() {
    this.accountService.cancelRegistration(this.testInfo.regId)
      .subscribe(() => {
        this.isRegistrationCancelRequested = true;
      },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
          else {
            this.toastService.warning("Your cancellation request cannot be processed, please contact Paragon for help.");
          }
        });
  }

  checkCancellationRequested() {
    this.accountService.checkCancellationRequested(this.regId)
      .subscribe(result => {
        this.isRegistrationCancelRequested = result.content;
      },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
        });
  }
}
